import api, { TOKEN_STORAGE_KEY, USER_STORAGE_KEY } from "./api";

export async function login(email, senha) {
  const { data } = await api.post("/Auth/login", { email, senha });
  // data: { token, expiresAt, guiaId, nome, email }
  localStorage.setItem(TOKEN_STORAGE_KEY, data.token);
  localStorage.setItem(
    USER_STORAGE_KEY,
    JSON.stringify({
      guiaId: data.guiaId,
      nome: data.nome,
      email: data.email,
      expiresAt: data.expiresAt,
    })
  );
  return data;
}

// Cadastro de novo guia. Endpoint /register devolve o MESMO AuthResponseDto
// do /login (token + dados básicos), então persistimos do mesmo jeito —
// usuária já entra logada após cadastrar (zero atrito).
// Rate limit: 5/h por IP (policy auth-register no backend).
export async function register({ nome, email, telefone, documento, senha }) {
  const { data } = await api.post("/Auth/register", {
    nome,
    email,
    telefone,
    documento,
    senha,
  });
  // Mesmas chaves do login — mesmo mecanismo de persistência.
  localStorage.setItem(TOKEN_STORAGE_KEY, data.token);
  localStorage.setItem(
    USER_STORAGE_KEY,
    JSON.stringify({
      guiaId: data.guiaId,
      nome: data.nome,
      email: data.email,
      expiresAt: data.expiresAt,
    })
  );
  return data;
}

export function logout() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(USER_STORAGE_KEY);
    if (!raw) return null;
    const user = JSON.parse(raw);
    if (user.expiresAt && new Date(user.expiresAt) < new Date()) {
      logout();
      return null;
    }
    return user;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!localStorage.getItem(TOKEN_STORAGE_KEY) && !!getStoredUser();
}
